import Vue from 'vue';
import Vuex from 'vuex';

import interactionModule from './interaction'
import customerResultsModule from './customerResults'
import iatModule from './iat'

import i18nModule from './i18n'

Vue.use(Vuex);

export const SET_APP_LOADING_PENDING = 'SET_APP_LOADING_PENDING'
export const SET_APP_LOADING_COMPLETE = 'SET_APP_LOADING_COMPLETE'
const SHOW_DIALOG = 'SHOW_DIALOG'
const CLOSE_DIALOG = 'CLOSE_DIALOG'

export default new Vuex.Store({
  state: {
    loading: false,
    dialog: null,
    app: {
      message: {
        type: null,
        message: '',
      }
    },
    isReady: false,
  },
  mutations: {
    SET_APP_LOADING_PENDING(state) {
      state.loading = true
    },
    SET_APP_LOADING_COMPLETE(state) {
      state.loading = false
    },
    SHOW_DIALOG(state, payload) {
      state.dialog = payload
    },
    CLOSE_DIALOG(state) {
      state.payload = null
    },
    SET_APP_READY(state, ready) {
      state.isReady = ready;
    }
  },
  getters: {
    appLoading: state => state.loading,
    dialog: state => state.dialog
  },
  actions: {
    async setLoadingUntilResolved({ commit }, promises) {
      commit(SET_APP_LOADING_PENDING)
      try {
        return await Promise.all(promises)
      } finally {
        commit(SET_APP_LOADING_COMPLETE)
      }
    },
    showDialog({ commit }, payload) {
      commit(SHOW_DIALOG, payload)
    },
    closeDialog({ commit }) {
      commit(CLOSE_DIALOG)
    }
  },
  modules: {
    interactionModule,
    customerResultsModule,
    iatModule,
    i18nModule,
  },
});